module.exports = __webpack_public_path__ + "img/0.ed3ac72e.png";